import { render } from "./partF.vue?vue&type=template&id=c07ac4cc"
import script from "./partF.vue?vue&type=script&lang=js"
export * from "./partF.vue?vue&type=script&lang=js"

import "./partF.vue?vue&type=style&index=0&id=c07ac4cc&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__